import { type FC, useCallback } from "react";

import { Checkbox } from "@snapchat/snap-design-system";

import { type SpecApprovalState } from "../../../../gql-generated/types";
import { LensStatusIndicator } from "../../../../lens/components/shared";
import { StatusName, lensFilterItemContainer, widthName } from "../../../../lenses/components/list/header";
import { Flexbox } from "../../../../shared/components";
import { mapApiStatus } from "../../../utils";

type OnClick = (state: SpecApprovalState) => void;

interface ApiFilterItem {
    value: SpecApprovalState;
    checked: boolean;
    updateFilter: OnClick;
}

export const ApiFilterItem: FC<ApiFilterItem> = ({ value, checked, updateFilter }) => {
    const { color, name } = mapApiStatus(value);
    const onClick = useCallback(() => {
        updateFilter(value);
    }, [value, updateFilter]);

    return (
        <Flexbox
            alignItems="center"
            justifyContent="space-between"
            className={lensFilterItemContainer}
            onClick={onClick}
        >
            <Checkbox value={checked} />
            <Flexbox alignItems="center" className={widthName}>
                <LensStatusIndicator background={color} />
                <StatusName>{name}</StatusName>
            </Flexbox>
        </Flexbox>
    );
};
